import { render, staticRenderFns } from "./CareimageTable.vue?vue&type=template&id=de60c05c&scoped=true&lang=pug"
import script from "./CareimageTable.vue?vue&type=script&lang=ts"
export * from "./CareimageTable.vue?vue&type=script&lang=ts"
import style0 from "./CareimageTable.vue?vue&type=style&index=0&id=de60c05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de60c05c",
  null
  
)

export default component.exports